const initialState = {
  isLoading: false,
};

export default {
  namespaced: true,

  state: initialState,

  mutations: {
    setIsLoading(state, val) {
      state.isLoading = val;
    },
  },

  actions: {
    withLoader({ commit }, action) {
      commit("setIsLoading", true);
      return action().finally(() => {
        commit("setIsLoading", false);
      });
    },
  },
};
